import { useParams } from 'react-router-dom';
import { Styled } from './index.styles';
import { Box, Container, Icon } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { useCallback, useEffect, useState } from 'react';
import strapiService from 'services/strapi/index.api';
import SEO from 'components/seo';
import moment from 'moment';
import { Loading } from 'components/loading';
import Title from 'components/title';
import Faqs from 'components/faqs';
import CityHeaderSection from 'widgets/bus/city-header-section';
import useBusService from 'services/bus/index.api';
import BusPopularBox from 'widgets/bus/bus-popular-box';
import DynamicBanners from 'components/dynamic-banners';

const BusCity = () => {
    let { city = '' } = useParams();
    const { searchOneCode } = useBusService();

    const [data, setData] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);
    const [bannerData, setBannerData] = useState<any>();

    const handleBannerData = useCallback(async (data: any) => {
        await strapiService
            .NewBanners({
                category: 'bus',
                subCategory: 'city',
                filters: {
                    toCode: String(data.CityCode),
                },
                lang: 'tr',
            })
            .then((res: any) => {
                setBannerData(res);
            })
            .catch((err: any) => {
                console.log('err:', err);
            });
    }, []);

    const handleData = useCallback(async () => {
        await strapiService
            .BusCity({ lang: 'tr', slug: city })
            .then((res: any) => {
                const data = res.data[0]?.attributes;
                if (data) {
                    setTimeout(() => {
                        setData(data);
                        handleSearch(data.CityCode, 'to');
                    });
                }
            })
            .catch((err: any) => {
                console.log('err:', err);
            });
    }, []);

    const [dataParam, setDataParam] = useState<any>({
        from: {
            label: '',
            code: '',
            name: '',
            city: '',
            country: '',
            id: '',
        },
        to: {
            label: '',
            code: '',
            name: '',
            city: '',
            country: '',
            id: '',
        },
        date: moment(new Date()).format('YYYY-MM-DD'),
    });

    const handleSearch = useCallback(async (code: any, where: any) => {
        await searchOneCode(code)
            .then((res: any) => {
                const item = res.data.hits.hits[0];
                const temp = dataParam;

                const tempData = {
                    label: `${item._source.StopName}`,
                    code: item._source.ID,
                    id: item._id,
                };
                if (where === 'to') {
                    temp.to = tempData;
                } else {
                    temp.from = tempData;
                }
                setDataParam(temp);
                setLoading(true);
            })
            .catch((err: any) => {
                console.log('err:', err);

                // alert('Beklenmeyen bir hata oldu.');
            });
    }, []);

    useEffect(() => {
        data && handleBannerData(data);
    }, [data]);

    useEffect(() => {
        handleData();
    }, []);

    return (
        <Styled>
            {loading ? (
                <>
                    {data.Seo && (
                        <SEO
                            title={data.Seo?.Title}
                            description={data.Seo?.Description}
                            keywords={data.Seo?.Keywords}
                        />
                    )}
                    <div className="custom-header">
                        {dataParam && (
                            <CityHeaderSection
                                img={`${process.env.REACT_APP_STRAPI_BASE_URL}${data.HeadImage.data.attributes.url}`}
                                title={data.HeadTitle}
                                gtm={data.SpecialTag ? 'city-' + data.Slug : 'city'}
                                data={dataParam}
                            />
                        )}
                    </div>
                    <Container className="container" maxWidth="lg">
                        <DynamicBanners data={bannerData} index={0} imageStyle={{ marginTop: 40, marginBottom: 0 }} />

                        <Box sx={{ flexGrow: 1, mb: 5, mt: 5 }}>
                            <Grid2 container spacing={3} className="mobile-reverse">
                                <Grid2 sm={12} md={12} lg={8}>
                                    <div className="paper-about">
                                        <div className="editor">
                                            <Title
                                                element="h2"
                                                size="large"
                                                weight="default"
                                                align="left"
                                                color="secondary"
                                            >
                                                <b>{data.CityName}</b> Hakkında
                                            </Title>
                                            <div
                                                className="content"
                                                dangerouslySetInnerHTML={{
                                                    __html: data.Content,
                                                }}
                                            ></div>
                                        </div>
                                    </div>
                                </Grid2>
                                <Grid2 sm={12} md={12} lg={4}>
                                    <div className="paper">
                                        <div className="feature-box-list">
                                            {data.Feature?.map((item: any, index: number) => {
                                                return (
                                                    <div className="box" key={index}>
                                                        <div className="icon">
                                                            <Icon>{item.Icon}</Icon>
                                                        </div>
                                                        <div className="content">
                                                            <div className="title">{item.Title}</div>
                                                            <div className="description">{item.Description}</div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </Grid2>
                            </Grid2>
                        </Box>
                    </Container>
                    {data.FromBusPopularRoute.length > 0 && data.FromBusPopularRoute.length > 0 && (
                        <Container className="container" maxWidth="md">
                            <Box sx={{ flexGrow: 1, mb: 5 }}>
                                <Grid2 container spacing={3} sm={12} md={12} lg={12} justifyContent={'center'}>
                                    <Grid2 sm={12} md={12} lg={12}>
                                        {data.FromBusPopularRoute.length > 0 && (
                                            <>
                                                <div className="bus-box secondary">
                                                    <Title element="h2" size="large" weight="default" color="secondary">
                                                        {data.CityName} Otobüs Bileti Fiyatları
                                                    </Title>
                                                </div>
                                                <div className="ticket-list">
                                                    {data.FromBusPopularRoute.map((item: any, index: number) => {
                                                        return (
                                                            <BusPopularBox
                                                                type="secondary"
                                                                item={item}
                                                                index={index}
                                                                key={index}
                                                            />
                                                        );
                                                    })}
                                                </div>
                                            </>
                                        )}
                                    </Grid2>
                                    <Grid2 sm={12} md={12} lg={12}>
                                        {data.FromBusPopularRoute.length > 0 && (
                                            <>
                                                <div className="bus-box primary">
                                                    <Title element="h2" size="large" weight="default" color="primary">
                                                        {data.CityName} Varışlı Otobüs Bileti Fiyatları
                                                    </Title>
                                                </div>
                                                <div className="ticket-list">
                                                    {data.ToBusPopularRoute.map((item: any, index: number) => {
                                                        return (
                                                            <BusPopularBox
                                                                type="primary"
                                                                item={item}
                                                                index={index}
                                                                key={index}
                                                            />
                                                        );
                                                    })}
                                                </div>
                                            </>
                                        )}
                                    </Grid2>
                                </Grid2>
                            </Box>
                        </Container>
                    )}
                    {data.BusContent && (
                        <Container className="container" maxWidth="md" sx={{ mb: 5 }}>
                            <Box sx={{ mb: 5 }}>
                                <Title element="h2" color="secondary" icon={<Icon>directions_bus</Icon>}>
                                    {data.CityName} Seferleri Hakkında Bilgiler
                                </Title>
                                <div
                                    className="content"
                                    dangerouslySetInnerHTML={{
                                        __html: data.BusContent,
                                    }}
                                ></div>
                            </Box>
                        </Container>
                    )}
                    {data.Faq.length > 0 && (
                        <Container className="container" maxWidth="lg">
                            <Box sx={{ flexGrow: 1, mb: 3 }}>
                                <Grid2 container spacing={3}>
                                    <Grid2 xs={12}>
                                        <div className="faq">
                                            <Container className="container" maxWidth="md">
                                                <Title element="h2" icon={<Icon>quiz</Icon>}>
                                                    {data.CityName} Hakkında Sıkça Sorulan Sorular
                                                </Title>
                                                <div className="faq-body">
                                                    <Faqs
                                                        data={data.Faq.map((item: any) => ({
                                                            title: item.Title,
                                                            content: item.Content,
                                                        }))}
                                                    />
                                                </div>{' '}
                                            </Container>
                                        </div>
                                    </Grid2>
                                </Grid2>
                            </Box>
                        </Container>
                    )}
                </>
            ) : (
                <Box
                    sx={{
                        minHeight: '100%',
                        minWidth: '100%',
                        position: 'fixed',
                        background: '#fff',
                        zIndex: 9999,
                    }}
                >
                    <Loading type="box" />
                </Box>
            )}
        </Styled>
    );
};
export default BusCity;
